import { useFetch } from "../../../hooks/fetch-data/config";
import { DownloadAttachment } from "../../../services/modules/loan";

export const INVOICE_FILE_NAME = "invoice";
export const INVOICE_PERIOD_FILE_NAME = "invoice_period";

export function useFetchInvoice({ loanId, installmentId, enabled = true }) {
  return useFetch({
    queryKeys: ["installmentReceipt", loanId, installmentId],
    queryFn: async () => {
      const blobUrl = await DownloadAttachment({
        body: {
          loan_id: Number(loanId),
          installment_id: installmentId ? Number(installmentId) : undefined,
          file_name: installmentId
            ? INVOICE_PERIOD_FILE_NAME
            : INVOICE_FILE_NAME,
        },
      });
      return blobUrl;
    },
    enabled: enabled && Boolean(loanId),
  });
}
